<div class="spinner">
  <app-loader></app-loader>
</div>
<div fxLayout="column" fxFlex="grow" class="dialog__container">
  <div mat-dialog-title class="dialog-title-row">
    <span class="header-font">{{LabelPrefernceName}}</span>
  </div>
  <div  fxLayout="column" fxFlex="grow">
    <form [formGroup]="orderPackageDialogForm" fxLayout="column" fxFlex="grow" fxLayoutGap="20px">
      <div  fxLayout="row" fxLayouAlign="none center" fxlayoutGap="10px"
        fxLayout.xs="column" fxLayout.sm="column">
        <mat-form-field class="controls-alignment">
          <mat-select matNativeControl formControlName="LabelPreference" disabled="true">
            @for (label of LabelPreferenceValues; track label) {
              <mat-option [value]="label">{{label}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      @if (showReqNumber) {
        <div fxLayout="row" fxLayouAlign="none center" fxlayoutGap="10px" fxLayout.xs="column"
          fxLayout.sm="column">
          <mat-form-field class="controls-alignment">
            <mat-label>Requisition#</mat-label>
            <input class="input-upper" matInput formControlName="RequisitionNumber" [errorStateMatcher]="esMatcher" maxlength="11" type="text" required>
            @if (orderPackageDialogForm.get('RequisitionNumber').hasError('required')) {
              <mat-error>Requisition# is mandatory</mat-error>
            }
            @if (orderPackageDialogForm.get('RequisitionNumber').hasError('reqDoesNotExist')) {
              <mat-error>
                Invalid requisition#, the requisition entered is not registered under {{packageAccountCode}} -
              {{packageAccountName}}</mat-error>
            }
            @if (orderPackageDialogForm.get('RequisitionNumber').hasError('invalidRequisitionFormat')) {
              <mat-error>Invalid Requisition Format. Correct format is R-P********, where * is any digit 0-9</mat-error>
            }
            @if (orderPackageDialogForm.get('RequisitionNumber').hasError('rangeDoesNotExists')) {
              <mat-error>
                There is no label range registered for the given account {{packageAccountCode}} - {{packageAccountName}},
              kindly register a range first in LabPort and try again</mat-error>
            }
            @if (orderPackageDialogForm.get('RequisitionNumber').hasError('requisitionUsed')) {
              <mat-error>Invalid requisition#, order with this requisition already exists</mat-error>
            }
            @if (orderPackageDialogForm.get('RequisitionNumber').hasError('pattern')) {
              <mat-error>Invalid Requisition Format. Correct format is R-P********, where * is any digit 0-9</mat-error>
            }
          </mat-form-field>
        </div>
      }
      <div name="Actions" fxLayout="row" fxFlexOffset="auto">
        <button mat-button color="primary" type="button"  (click)="closeDialog()">Cancel</button>
        <button mat-flat-button color="primary" type="submit"
          [disabled]="orderPackageDialogForm.pending || orderPackageDialogForm.invalid"
          (click)="submitCloseDialog()" fxFlexOffset="auto"> Add
        </button>
      </div>

    </form>
  </div>
</div>

